import { gql } from '@apollo/client';

export const OrderChipFragment = gql`
    fragment OrderChipFragment on Order {
        id
        externalId
        discontinuedAt
        isPaused
        timezone
        prn {
            authorizedVisitCount
        }
        frequency {
            intervalCount
            intervalUnit
            numVisitsPerInterval
            unitsPerInterval
        }
        permissions {
            id
            viewDetails
        }
    }
`;
